import {useQuery} from '@tanstack/react-query';
import {API, isInboxAccessDenied} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useReservation} from 'context/reservation';

function useChatSettings(housingIdOverride?: string) {
  const {housing, isLoading: isReservationLoading} = useReservation();
  const housingId = housingIdOverride ?? housing?.id;
  const hasInboxAccess = !isInboxAccessDenied();
  const shouldFetchSettings = hasInboxAccess && Boolean(housingId);

  const {data: settings, isLoading: isSettingsLoading} = useQuery({
    queryKey: [QUERY_CACHE_KEYS.chatSettings],
    queryFn: () => API.communications.getGuestAppSettings(),
    enabled: shouldFetchSettings,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  const isLoading =
    (hasInboxAccess && !housingIdOverride && isReservationLoading) || isSettingsLoading;

  const isChatEnabled =
    hasInboxAccess &&
    Boolean(housingId) &&
    !!settings &&
    settings.enabled &&
    settings.property_ids.includes(housingId!);

  return {isChatEnabled, isLoading};
}

export {useChatSettings};
